import { ReactNode } from "react"

import cssModule from "./index.module.scss"

export type AdditionalInfoProps = {
	additionalInfo: string | ReactNode
}

export function AdditionalInfo({ additionalInfo }: AdditionalInfoProps) {
	if (!additionalInfo) return null

	return (
		<div className={cssModule.topbarAdditionalInfoCss}>
			<div className="no-underline text-[1.2rem]">{additionalInfo}</div>
		</div>
	)
}
